import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 16,
    height: 16,
    // Inherit the parent SidebarItem color so the icon follows the shared
    // grey (inactive) / blue (hover and selected) sidebar states.
    color: 'inherit',
  },
});

/**
 * Scales icon for the Compliance Management sidebar entry.
 */
export const CustomExceptionsIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.30708 8.29286C1.91656 8.68339 1.91656 9.31655 2.30708 9.70708L5.59998 13H2V14H14V13H8.29549L13.7148 7.58065C14.1053 7.19013 14.1053 6.55696 13.7148 6.16644L9.78126 2.2329C9.39074 1.84237 8.75758 1.84237 8.36705 2.2329L2.30708 8.29286ZM3.65789 8.35627L8.43045 3.58372L7.98636 7.47214C7.95995 7.70335 7.77753 7.88577 7.54632 7.91218L3.65789 8.35627ZM6.59418 12.58L3.40578 9.39156L7.65979 8.90572C8.35341 8.8265 8.90068 8.27923 8.9799 7.58561L9.46574 3.33158L13.0077 6.87355L7.30129 12.58C7.10602 12.7752 6.78944 12.7752 6.59418 12.58Z"
        fill="currentColor"
      />
    </svg>
  );
};
